/* eslint-disable import/prefer-default-export */
import { ALL_TEST_SERIES, FREE_CLASSES_AND_TESTS } from '@constants/segment';

export const getCustomPageDetails = (goalName, goalTitle, pageName) => {
  let pageCustomDetails;
  switch (pageName) {
    case ALL_TEST_SERIES:
      pageCustomDetails = {
        title: `Tests for ${goalName}`,
        testWithTitleCombats: `Test series for ${goalName}`,
        description: `Attempt ${goalName} free mock tests & test series curated by our educators to boost your preparation.`,
        testSeriesBlockTitle: `${goalName} Test series`,
        testSeriesBlockDescription: `Evaluate your exam preparation with test series for ${goalTitle}`,
        combatsBlockTitle: `${goalName} combats`,
        combatsBlockDescription:
          'Compete live with your peers to earn scholarships'
      };
      break;
    case FREE_CLASSES_AND_TESTS:
      pageCustomDetails = {
        title: `Free classes for ${goalName}`,
        description: `Watch free online coaching classes for ${goalName} by our best educators. You can watch free recorded and live classes.`,
        CUSTOM_FEED: {
          live_now: {
            label: 'Free live classes',
            description: 'Interact with educators in live classes for free'
          },
          trending: {
            label: 'Trending classes',
            description: `Watch popular classes for ${goalName}`
          },
          popular_subjects: {
            label: `Popular subjects for ${goalName} preparation`,
            description:
              'Browse subject-wise free classes with full syllabus coverage'
          },
          upcoming: {
            label: 'Upcoming free classes',
            description: `Get notified for Upcoming ${goalName} online classes`
          },
          educators: {
            label: `Popular educators in ${goalName}`,
            description:
              'Watch online classes from our popular educators for free.'
          }
        }
      };
      break;
    default:
      pageCustomDetails = {};
  }
  return pageCustomDetails;
};
